export const environment = {
  production: true,
  buildId: '13377-20261102.2'
};

